/* --------------------------------------------------------------------------
	Home
-------------------------------------------------------------------------- */

"use strict";

var $ = jQuery;
import 'fastdom';
import '../base/swap.js';

var $home_feature,
	$header,
	$feature_video,
	$feature_intro,
	$feature_body,
	$feature_body_inner,
	$feature_body_heading,
	$feature_controls,
	$feature_control_toggle,
	$feature_items_list,
	$feature_items,
	ActiveSection,
	LastScrollTop;

	function initHome() {
		$home_feature = $(".js-home-feature");
		if ( $home_feature.length ) {
			$header = $(".js-header");
			$feature_video = $("video", $home_feature);
			$feature_intro = $(".js-home-feature-intro");
			$feature_body = $(".js-home-feature-body");
			$feature_body_inner = $(".js-home-feature-body-inner");
			$feature_body_heading = $(".js-home-feature-body-heading");
			$feature_controls = $(".js-home-feature-controls");
			$feature_control_toggle = $(".js-home-feature-controls-item-toggle");
			$feature_items_list = $(".js-home-feature-list");
			$feature_items = $(".js-home-feature-item");

			ActiveSection = $feature_control_toggle[0].innerText.toLowerCase().replace(/\s/g, "_");
			LastScrollTop = -1;

			bindUI();
			$(window)
				.on("resize.home", onResize)
				.on("scroll.home", onScroll);
			
			onResize();
			onScroll();
		}
	}

	function bindUI() {
		$feature_control_toggle.on("click", controlActivate);		
	}

	// Returns value between 0 and 1 as 'value' moves
	// from 'invisible' to 'visible'.
	function fade(value, invisible, visible) {
		var scale = invisible - visible;
		if (-0.001 < scale && scale < 0.001) {
			// Too close to division by zero
			return 1;
		}
		var scaledValue = (invisible - value) / scale;

		// Clamp to 0..1
		return Math.min(Math.max(scaledValue, 0), 1);
	}

	function onScroll() {

		// .js-home-feature-intro ("A life changing experience" and item headings)
		//   top in lower 70% of viewport
		//     - play video
		//   top above 30% of viewport
		//     - pause video
		//     - began fadout
		//   top is above .js-header
		//     - end fade out
		//
		// .js-home-feature-body-heading "Adelphi builds success"
		//   class="show" when .js-home-feature-intro top above header 
		//   Opacity = (.js-home-feature-intro top above header) ? 1 : 0
		//   class="fade-out" when first feature-item above 45% of viewport
		//
		// .js-home-feature-item if WindowWidth >= 740
		//   top @ 70%
		//     - opacity 1
		//   top @ 90%
		//     - opacity 0 
		//
		// .js-home-feature-item if WindowWidth < 740
		//    opacity 1
		//
		// ActiveSection = id of:
		//   bottom-most .js-home-feature-item top above %55 scrolling down
		//   top-most .js-home-feature-item bottom below %50 scrolling up
		//

		var featureIntroOpacity, 
			playVideo,
			pauseVideo,
			featureBodyHeadingShow,
			featureBodyHeadingFadeOut,
			featureControlsShow,
			featureBodyHeadingOpacity,
			featureItemOpacities = [];

		fastdom.measure(function () {
			var scrollTop = window.pageYOffset;
			var ScrollDirection = (scrollTop > LastScrollTop) ? "down" : "up";
			LastScrollTop = scrollTop;
	
			var HeaderHeight = $header.height();
			var WindowWidth = $(window).width();
			var verticalHeight = window.innerHeight;
			var feature_intro_top = $feature_intro[0].getBoundingClientRect().top;

			featureIntroOpacity = fade(feature_intro_top, HeaderHeight, verticalHeight * 0.3);

			// Background video
			var playingLive = !$home_feature.hasClass("paused");
			var playVideoGoal = feature_intro_top >= verticalHeight * 0.3;;
			playVideo = playVideoGoal && !playingLive;
			pauseVideo = !playVideoGoal && playingLive;

			// "Adelphi Builds Success", above section controls
			featureBodyHeadingShow = feature_intro_top < HeaderHeight;

			// "The Adelphi Difference" and section list
			featureControlsShow = feature_intro_top < 0;

			// Actually triggers animation?
			featureBodyHeadingOpacity = featureBodyHeadingShow ? 1 : 0;

			var featureItemsTop = $feature_items[0].getBoundingClientRect().top;
			featureBodyHeadingFadeOut = featureItemsTop < verticalHeight * 0.45;

			var set_active = false;
			$feature_items.each(function(index) {
				var item_top = $(this)[0].getBoundingClientRect().top;
				if (WindowWidth >= 740) {
					featureItemOpacities[index] = fade(item_top, verticalHeight * 0.9, verticalHeight * 0.7);
				} else {
					featureItemOpacities[index] = 1;
				}

				if (ScrollDirection == 'down') {
					if (item_top < verticalHeight * 0.55) {
						ActiveSection = $(this).attr('id');
					}

				} else if (!set_active) { // 'up'
					if ($(this)[0].getBoundingClientRect().bottom > verticalHeight * 0.5) {
						set_active = true;
						ActiveSection = $(this).attr('id');
					}
				}
			});
		});

		fastdom.mutate(function () {
			$feature_intro.css("opacity", featureIntroOpacity);
			$feature_body_heading.css("opacity", featureBodyHeadingOpacity);
			$feature_items.each(function(index) {
				$(this).css("opacity", featureItemOpacities[index]);
			});

			if (playVideo) {
				if ($feature_video.length > 0) {
					$feature_video[0].play();
				}
				$home_feature.removeClass("paused");
			}
			if (pauseVideo) {
				if ($feature_video.length > 0) {
					$feature_video[0].pause();
				}
				$home_feature.addClass("paused");
			}

			if (featureControlsShow) {
				$feature_controls.addClass("show");
			} else {
				$feature_controls.removeClass("show");
			}

			if (featureBodyHeadingShow) {
				$feature_body_heading.addClass("show");
			} else {
				$feature_body_heading.removeClass("show");
			}
			if (featureBodyHeadingFadeOut) {
				$feature_body_heading.addClass("fade-out");
			} else {
				$feature_body_heading.removeClass("fade-out");
			}

			activateFeature(ActiveSection);
		});
	}

	function onResize() {
		resizeItems();
	}

	function resizeItems() {
		// feature_items_list has "position: absolute" so its size isn't
		// included in parent's (feature_body_inner). Unclear why "list" 
		// has "position: absolute". It needs to be on right side and
		// otherwise is default ish?

		var ItemsHeight;
		var BodyHeight;
		var WindowWidth;	

		fastdom.measure(function () {
			ItemsHeight = $feature_items_list.outerHeight() + 100;
			BodyHeight = $feature_body_inner.height();
			WindowWidth = $(window).width();
		});

		fastdom.mutate(function () {
			if (WindowWidth >= 980) {
				// There was logic if $feature_items_list was shorter
				// then $feature_body_inner's other contents. It's hard
				// to figure that out.
				$feature_body_inner.css("height", (ItemsHeight) + "px");
			} else {
				$feature_body_inner.removeAttr("style");
			}
		});
	}

	function activateFeature(id) {
		var section = "#" + id;
		$feature_control_toggle.each(function() {
			if( $(this).attr("href") == section ) {
				if( !$(this).hasClass("fs-swap-active") ) {
					$(this).swap("activate");
				}
			}
		})
	}

	function controlActivate(event) {
		event.preventDefault();
		var section = $(this).attr("href");
		var top;

		fastdom.measure(function () {
			top = $(section).offset().top - (window.innerHeight * 0.4)
		});

		fastdom.mutate(function () {
			$('html, body').animate({
				scrollTop: parseInt(top)
			}, 500);
		});
	}

	$(initHome);
